export default __webpack_public_path__ + "/dist/images/buy-icon.svg";